jQuery( function( $ ) {

	/**
	 * Adds selectize to all select fields.
	 */
	$( 'select' ).not( '.filter-dropdown' ).selectize();

} );
